<template>
  <div :class="['post-content-wrapper', { 'preview': preview }]">
    <proa-avatar
      size="sm"
      :src="privateChatPost.user.meta.avatar || require('@/assets/images/avatar_default.png')"
      class="post-user-avatar"
      @mouseover.native.stop="$emit('onMouseOverChatPostItem')"
    />
    <div class="post-body">
      <div>
        <span class="post-user-display-name">
          {{ privateChatPost.user.meta.displayName }}
        </span>
        <span class="post-created-at">
          {{ privateChatPost.createdAt | moment('YYYY/MM/DD HH:mm') }}
          <span v-if="privateChatPost.createdAt != privateChatPost.updatedAt">（{{ $t('common.edited') }}）</span>
        </span>
      </div>
      <div
        v-if="!editing"
        v-html="$options.filters.formatChatPostContentWithMention(privateChatPost.content)"
        class="post-content"
        :key="contentBindKey"
      />
      <div v-if="!editing" class="link-previews">
        <link-preview
          v-for="linkPreview in privateChatPost.linkPreviews"
          :key="linkPreview"
          :url="linkPreview"
        />
      </div>
      <div v-if="!editing" class="attachments">
        <div
          v-for="attachment in privateChatPost.privateChatAttachmentsAttributes"
          :key="attachment.id"
          class="attachment"
          @click="onClickAttachment(attachment)"
          @mouseover.stop="$emit('onMouseOverChatPostItem')"
        >
          <span class="attachment-icon">
            <img :src="require('@/assets/images/icons/file.png')"/>
          </span>
          <span class="attachment-file-name">
            {{ attachment.attachmentFileName }}
          </span>
        </div>
      </div>
      <div v-if="!editing && privateChatPost.privateChatReactions.length" class="reactions">
        <proa-tooltip
          v-for="reaction in computedReactions"
          :key="reaction.reactionId"
          :class="['reaction', { 'reacted': reaction.userIds.includes(signedInUser.id) }]"
          @click.native="onClickReaction(reaction.reactionId)"
          @mouseover.native.stop="$emit('onMouseOverChatPostItem')"
        >
          <template v-slot:tooltip>
            <div class="reacted-user-display-names">
              <div
                v-for="displayName in getReactedUserDisplayNames(reaction.userIds)"
                :key="displayName"
                class="display-name"
              >
                {{ displayName }}
              </div>
            </div>
          </template>
          <span class="reaction-icon">
            <img :src="reaction.master.reactionImage.url"/>
          </span>
          <span class="reaction-count">{{ reaction.userIds.length }}</span>
        </proa-tooltip>
      </div>
      <div v-if="editing" class="edit-flex-item">
        <private-chat-post-editor
          :privateChatPost="innerChatPost"
          type="edit"
          @onCancelEditChatPost="$emit('onCancelEditChatPost')"
          @onClickNewAttachment="$emit('onClickNewAttachment', innerChatPost)"
          @onClickRemoveAttachment="(index) => $emit('onClickRemoveAttachment', index)"
          @onSubmitChatPost="$emit('onSubmitChatPost', innerChatPost)"
        />
      </div>
    </div>
    <attachment-modal
      :avatarUrl="privateChatPost.user.meta.avatar"
      :attachment="attachmentModalObject"
      @close="attachmentModalObject = null"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PrivateChat from '@/store/models/PrivateChat'
import User from '@/store/models/User'

import LinkPreview from '@/components/organisms/LinkPreview'
import AttachmentModal from '@/components/molecules/AttachmentModal'
import PrivateChatPostEditor from '@/components/organisms/PrivateChatPostEditor'

export default {
  name: 'PrivateChatPostContent',
  components: {
    LinkPreview,
    AttachmentModal,
    PrivateChatPostEditor
  },
  props: {
    contentBindKey: String,
    privateChatPost: Object,
    editing: {
      type: Boolean,
      default: false
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    privateChat: function() {
      return PrivateChat.find(this.privateChatPost.privateChatId)
    },
    computedReactions: function() {
      return this.privateChatPost.computedReactions()
    },
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  data() {
    return {
      innerChatPost: null,
      attachmentModalObject: null
    }
  },
  methods: {
    getReactedUserDisplayNames: function(userIds) {
      return User.query().whereIdIn(userIds).get().map(user => user.meta.displayName)
    },
    onClickAttachment: function(attachment) {
      this.attachmentModalObject = attachment
    },
    async onClickReaction(reactionId) {
      const reactedReaction = this.privateChatPost.privateChatReactions.find(privateChatReaction => {
        return privateChatReaction.reactionId == reactionId
               && privateChatReaction.userId == this.signedInUser.id
      })
      if (reactedReaction) {
        await this.apiDeletePrivateChatPostReactions({
          userId: this.privateChat.userId,
          privateChatPostId: this.privateChatPost.id,
          id: reactedReaction.id
        })
      } else {
        await this.apiPostPrivateChatPostReactions({
          userId: this.privateChat.userId,
          privateChatPostId: this.privateChatPost.id,
          attributes: {
            reactionId: reactionId
          }
        })
      }
    },
    ...mapActions({
      apiPostPrivateChatPostReactions: 'privateChatPostReactions/create',
      apiDeletePrivateChatPostReactions: 'privateChatPostReactions/destroy',
    })
  },
  watch: {
    editing: function(value) {
      if (value) {
        this.innerChatPost = Object.assign({}, this.privateChatPost)
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
